import { useEffect, useState } from 'react';

export const useAppVisibility = () => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const syncFromVisibility = () =>
            setIsVisible(document.visibilityState === 'visible');

        const setTrue = () => setIsVisible(true);
        const setFalse = () => setIsVisible(false);

        // همگام‌سازی اولیه
        syncFromVisibility();

        // دریافت سیگنال اولیه (زمانی که اپ در حال بازگشت است)
        window.addEventListener('focus', setTrue, { passive: true });
        window.addEventListener('blur', setFalse, { passive: true });

        // دریافت سیگنال نهایی و صحیح
        document.addEventListener('visibilitychange', syncFromVisibility, { passive: true });

        return () => {
            window.removeEventListener('focus', setTrue);
            window.removeEventListener('blur', setFalse);
            document.removeEventListener('visibilitychange', syncFromVisibility);
        };
    }, []);

    return isVisible;
};